const config = require("../config.js");
module.exports = function () {
  this.locale = "en";
  this.defaultLocale = "en";
  this.supported = Object.keys(config.langNames);
  this.translations = {};
  this.parseText = function (p7575) {
    var vA340 = [];
    p7575.split("\n").filter(p7576 => p7576).forEach(p7577 => {
      var v6311 = p7577.split(" ");
      vA340[v6311[0]] = v6311.slice(1).join(" ");
    });
    return vA340;
  };
  this.translations.en = this.parseText(require("../i18n/en.js"));
  this.getTranslations = function (p7578) {
    if (!this.translations[p7578]) {
      const v6312 = new XMLHttpRequest();
      v6312.open("GET", "i18n/" + p7578 + ".js?v=AD9yU", false);
      v6312.send(null);
      if (v6312.status === 200) {
        this.translations[p7578] = this.parseText(v6312.responseText);
      }
    }
  };
  this.saveLocale = function () {
    currentStorage.setItem("krk_lang", this.locale || this.defaultLocale);
  };
  this.setLocale = function (p7579) {
    if (this.supported.indexOf(p7579) > -1) {
      this.locale = p7579;
    }
    this.saveLocale();
  };
  this.setLocaleFromStorage = function () {
    if (typeof Storage != "undefined") {
      this.setLocale(currentStorage.getItem("krk_lang"));
    }
  };
  this.setLocaleFromStorage();
  this.encode = function (p7580) {
    var vA341 = [];
    for (var v6313 = p7580.length - 1; v6313 >= 0; v6313--) {
      vA341.unshift(["&#", p7580[v6313].charCodeAt(), ";"].join(""));
    }
    return vA341.join("");
  };
  this.get = function (p7581) {
    this.getTranslations(this.locale || this.defaultLocale);
    let v6314 = this.translations[this.locale][p7581] || this.translations[this.defaultLocale][p7581] || "UNLOCALIZED STRING";
    v6314 = this.replacePlaceholders(v6314, [...arguments].slice(1));
    return v6314;
  };
  this.t = this.get;
  this.has = function (p7582) {
    this.getTranslations(this.locale || this.defaultLocale);
    let v6315 = this.translations[this.locale][p7582] || this.translations[this.defaultLocale][p7582] || false;
    if (v6315) {
      v6315 = this.replacePlaceholders(v6315, [...arguments].slice(1));
    }
    return v6315;
  };
  this.replacePlaceholders = function (p7583, p7584) {
    return p7583.replace(/\{(\d)\}/gm, (p7585, p7586) => p7584[p7586 || 0] == null ? "" : p7584[p7586 || 0]);
  };
  this.h = this.has;
};